import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 62.5%;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  html,
  body {
    height: 100%;
    margin: 0;
  }
  body {
    background: #3c1638;
    color: #fff;
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.6rem;
    line-height: 160%;
    padding: 71px 0 0;

    @media only screen and (min-width: 640px) {
      font-size: 1.8rem;
      line-height: 150%;
    }

    @media only screen and (min-width: 1200px) {
      padding: 91px 0 0;
    }

    @media only screen and (min-width: 1600px) {
      font-size: 2rem;
      line-height: 160%;
    }

    &.theme-black {
      background: black;
      padding-top: 0;

      main {
        min-height: auto;

        @media only screen and (min-width: 1024px) {
          height: 100vh;
          display: flex;
          align-items: center;
        }
      }

      .row {
        padding: 0;
      }

      .notFound__content {
        padding: 20px;
      }

      header,
      footer {
        display: none;
      }
    }
  }
  button {
    padding: 0;
    cursor: pointer;
    font-family: 'Lato', sans-serif;
  }
  p {
    line-height: inherit;
    margin: 0 0 2rem;
  }
  iframe {
    background: #2e1b2b;
    margin: 45px -15px 0;
    width: calc(100% + 30px);

    @media only screen and (min-width: 640px) {
      margin: 45px -20px 0;
      width: calc(100% + 40px);
    }

    @media only screen and (min-width: 1200px) {
      margin: 45px 0 0;
      width: 100%;
    }
  }
  dt,dd {
    margin: 0;
  }

  h1,h2,h3 {
    /* color: #5dd882; */
    color: #fff;
    line-height: 130%;

    a {
      text-decoration: none;
    }
  }

  h1 {
    margin-block-start: 0.67em;

    span {
      display: block;
    }
  }

  h1 {
    font-size: 2.6rem;
    margin-bottom: 1.8rem;
  }

  h2 {
    font-size: 2.6rem;
    margin-bottom: 1.8rem;
    /* text-align: center; */
  }

  h2 {
    margin-top: 5rem;
  }

  h3 {
    font-size: 2rem;
    margin-bottom: 16px;
    margin-top: 6rem;
  }

  h4 {
    margin-bottom: 12px;
  }

  ol.list-decimal {
    counter-reset: counter;
    list-style: none;
    margin: 0 0 50px;

    li {
      counter-increment: counter;

      h3 {
        position: relative;

        &::before {
          color: #c75784;
          content: counter(counter) ".";
          font-weight: 600;
          left: -35px;
          position: absolute;
          top: 0;
        }
      }
    }
  }

  .star {
    font-size: 4rem;
    line-height: 28px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
  }

  .breadcrumbs {
    font-size: 1.5rem;
    list-style: none;
    padding: 0;

    li {
      display: inline-block;
      line-height: 140%;
      margin-right: 8px;

      &:first-child {
        &::before {
          display: none;
        }
      }

      &::before {
        content: "❯";
        color: #c8608b;
        font-size: 1rem;
        padding-right: 7px;
        position: relative;
        top: -1px;
      }
    }
  }

  @media only screen and (min-width: 480px) {
    h2 {
      margin: 0;
      overflow: hidden;
      padding: 6rem 0 3rem;

      span {
        position: relative;

        &::before,
        &::after {
          content: '';
          border-top: 1px solid rgba(199,87,132,0.25);
          position: absolute;
          top: calc(50% + 4px);
          width: 300%;
        }

        &::before {
          right: calc(100% + 20px);
        }

        &::after {
          left: calc(100% + 20px);
        }
      }
    }
  }

  @media only screen and (min-width: 640px) {
    h1 {
      font-size: 3.2rem;
    }
  }

  @media only screen and (min-width: 960px) {
    h1 {
      font-size: 3.8rem;
      line-height: 120%;
      margin-bottom: 3rem;
      text-align: left;
    }

    h2 {
      font-size: 3rem;
    }

    h3 {
      font-size: 2.4rem;
    }

    h4 {
      font-size: 2.1rem;
    }
  }

  @media only screen and (min-width: 1600px) {
    h1 {
      font-size: 4.2rem;
    }

    h2 {
      font-size: 3.6rem;
    }
  }

  ul {
    margin: 0;
  }
  main {
    padding-bottom: 80px;

    a:not(.btn--more):not(.btn--white)  {
      border-bottom: 1px solid rgba(93, 216, 130, .4);
      background: linear-gradient(0deg, #fff, #fff) no-repeat right bottom / 0 var(--bg-h);
      transition: color 150ms, background-size 250ms;
      --bg-h: 1px;

      &:hover,
      &:focus {
        background-size: 100% var(--bg-h);
        background-position-x: left;
      }
    }
  }

  .btn--more {
    span {
      border-bottom: 1px solid rgba(93, 216, 130, .4);
      background: linear-gradient(0deg, #fff, #fff) no-repeat right bottom / 0 var(--bg-h);
      transition: background-size 250ms;
      --bg-h: 1px;
    }

    &:hover,
    &:focus {
      span {
        background-size: 100% var(--bg-h);
        background-position-x: left;
      }
    }
  }

  a {
    color: #5dd882;
    cursor: pointer;
    text-decoration: none;
    transition: color 150ms ease-in, border-color 150ms ease-in;

    &:hover,
    &:focus {
      color: #fff;
    }

    &:focus {
      background: rgba(199,87,132,0.3);
      outline: 1px dotted #c75784;
    }
  }
  cite {
    border-left: 3px solid #c75784;
    background: rgba(199,87,132,0.1);
    font-style: italic;
    max-width: 640px;
    border-radius: 3px;
    display: block;
    margin: 50px 0;
    padding: 15px 20px 20px 25px;
    line-height: 140%;

    .author {
      font-style: normal;
      display: block;
      text-align: right;
      margin: 30px 0 0;
      font-size: 1.6rem;
    }
  }
  figure {
    margin: 50px 0;
  }
  figcaption {
    font-style: italic;
    margin: 15px 0 0;
    text-align: center;
  }
  img {
    height: auto;
    max-width: 100%;
  }
  .row {
    margin-inline: auto;
    width: min(100%, 1200px);
    padding: 10px 15px;

    @media only screen and (min-width: 640px) {
      padding: 20px;
    }
  }
  sup {
    line-height: 0;
    font-size: 1.4rem;
    margin: 0;
    position: relative;
    top: 2px;
  }
  .btn {
    transition: background 200ms ease-in, color 200ms ease-in;
    background: #5dd882;
    border: 0;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-weight: 600;
    padding: 7px 25px 9px;
    text-decoration: none;

    &:hover {
      background: #49ed7a;
      color: #fff;
    }

    &:focus {
      color: #fff;
      background: none;
    }
  }

  .text-center {
    text-align: center;
  }

  .no-marg {
    margin: 0;
  }

  .btn--white {
    transition: opacity 150ms ease-in;
    background: #fff;
    border-radius: 3px;
    /* box-shadow: 0 4px #5dd882; */
    color: #000;
    display: inline-block;
    font-size: 1.6rem;
    padding: 8px 24px;
    text-decoration: none;

    &:hover,
    &:focus {
      color: #000;
    }

    &:hover {
      opacity: .5;
    }

    &:focus {
      box-shadow: 0 0 0 4px #5dd882;
      background: #fff;
      outline: none;
      opacity: 1;
    }

    img {
      margin: 0 10px 0 0;
      position: relative;
      top: -2px;
      width: 24px;
      vertical-align: middle;
    }
  }

  .btn--outline {
    transition: color 150ms ease-in, border-color 150ms ease-in!important;
    background: none;
    border: 1px solid #5dd882!important;
    border-radius: 4px;
    color: #5dd882;
    text-transform: none;

    &:hover,
    &:focus {
      border-color: #fff!important;
      color: #fff!important;
      background: none!important;
    }
  }

  .btn--more {
    &:hover,
    &:focus {
      svg {
        path {
          stroke: #fff;
        }
      }
    }
    svg {
      margin-left: 10px;
      position: relative;
      top: 2px;

      path {
        transition: stroke 150ms;
      }
    }
  }

  .section-text {
    border-bottom: 1px solid rgba(199,87,132,0.25);
    max-width: 900px;
    padding: 0 0 45px;

    ul {
      margin-bottom: 5rem;
    }

    &--no-border {
      border: 0;
    }

    &:last-of-type,
    &--no-border {
      border-bottom: 0;
    }
  }

  .section-services {
    border-top: 1px solid rgba(199,87,132,0.25);
    margin-top: 45px;
  }

  .scroll-box {
    /* margin: 0 -15px 5rem; */
    margin: 0 -15px 24px;
    padding: 0 15px;
    overflow-x: auto;
    scrollbar-color: #c75784 transparent;

    table {
      margin: 0 0 10px!important;
    }
  }

  table {
    border: 1px solid rgba(199, 87, 132, 0.25);
    border-spacing: 0;
    font-size: 1.6rem;
    margin: 0 0 1rem;
    max-width: 100%;
    min-width: 900px;
    width: 100%;

    sup {
      color: #f00;
      font-size: 2rem;
      position: relative;
      top: 6px;
    }

    th,td {
      border: 1px solid rgba(199, 87, 132, 0.25);
      text-align: left;
    }

    th {
      background: #340f2f;
      padding: 5px;
      text-align: center;
    }

    tbody {
      td {
        transition: background 100ms ease-in;
        height: 45px;
        padding: 0 5px;

        &:nth-child(1),
        &:nth-child(2) {
          text-align: right;
        }

        &:nth-child(6),
        &:nth-child(9) {
          text-align: center;
        }
      }

      tr {
        /* &:nth-child(even) {
          td {
            background: #361532;
          }
        } */

        &:hover td {
          background: #45153f;
        }
      }
    }

    tfoot {
      td {
        font-size: 14px;
        padding: 10px 15px 10px 20px;
        text-align: left;

        a {
          border: 0!important;
        }

        p {
          margin: 0;
        }
      }
    }
  }

  table.tab-fancy {
    background: #fff;
    border-collapse: inherit;
    border: 0!important;
    min-width: 280px;
    font-size: 1.2rem;
    margin: 6rem auto!important;

    &--center {
      tbody {
        td {
          text-align: center!important;
        }
      }
    }

    &--amrogowicz {
      tbody {
        td {
          &:nth-child(2) {
            text-align: right;
          }

          &.bar-cell {
            width: 140px;
          }
        }
      }
    }

    &--jeneral {
      .bar-cell {
        width: auto!important;
      }

      th,
      td {
        &:nth-child(1) {
          width: 45px;
        }
      }
      td {
        &:nth-child(2),
        &:nth-child(3) {
          text-align: right!important;
        }
      }
      td {
        &:nth-child(5) {
          text-align: left;
        }
      }
      td {
        &:nth-child(6) {
          font-weight: 400!important;
          text-align: center!important;
        }
      }
    }

    &--mint {
      tbody {
        tr:hover td {
          background: transparent;
        }
        tr:nth-child(even):hover td {
          background: #f9fafc;
        }
        td {
          /* background: #fff!important; */
          height: auto;
          line-height: 130%;
          padding: 7px 10px;
          text-align: left;

          img {
            max-width: max-content;
          }

          &:nth-child(1) {
            height: 125px;
            min-width: 305px;
            padding: 0;
          }

          &:nth-child(2) {
            font-weight: 400;
            min-width: 150px;
            text-align: left;
          }

          &:nth-child(3) {
            min-width: 150px;
            text-align: left;
          }
        }
      }
    }

    &--parchimowicz {
      td {
        text-align: center!important;
      }
    }

    &--population {
      tbody {
        td {
          &:first-child {
            text-align: center;
          }
          &:last-child {
            text-align: left;
          }
        }
      }
    }

    &--top {
      tbody {
        tr {
          &:nth-child(1) {
            td:nth-child(1) {
              background: #ffd000;
            }
          }
          &:nth-child(2) {
            td:nth-child(1) {
              background: silver;
            }
          }
          &:nth-child(3) {
            td:nth-child(1) {
              background: #c9521e;
              color: #fff;
            }
          }
        }
      }
    }

    &--solidarnosc {
      td {
        &:nth-child(3) {
          text-align: left;
        }
        &:nth-child(1),
        &:nth-child(5),
        &:nth-child(6) {
          text-align: right;
        }
      }
    }

    &--high-relief {
      tbody {
        td {
          &:nth-child(1) {
            text-align: center;
          }
          &:nth-child(2) {
            font-weight: 400;
          }
        }
      }
    }

    &--specimen {
      tbody {
        td {
          &:nth-child(1) {
            font-weight: 600;
            text-align: center;
          }
          &:nth-child(2),
          &:nth-child(6) {
            font-weight: 400;
          }
          &:nth-child(6) {
            text-align: left;
          }
        }
      }
    }

    &--sticky-auto {
      thead {
        tr {
          &:nth-child(2) {
            position: static!important;
          }
        }
      }
    }

    @media only screen and (min-width: 480px) {
      font-size: 1.4rem;
    }

    @media only screen and (min-width: 800px) {
      font-size: 1.6rem;
      max-width: 700px;
    }

    @media only screen and (min-width: 640px) {
      tfoot {
        p {
          display: inline-block;

          & + p {
            margin-left: 8px;

            &::before {
              content: "|";
              padding-right: 8px;
            }
          }
        }
      }
    }

    thead {
      tr {
        &:nth-child(2) {
          position: sticky;
          top: 70px;
          z-index: 3;

          @media only screen and (min-width: 1200px) {
            top: 90px;
          }

          th {
            background: #202f44;
          }
        }
      }
    }

    th {
      background: #031124;
      border: 0;
      border-right: 1px solid #031124;
      font-size: 1.3rem;

      &:first-child {
        border-left: 1px solid #031124;
      }

      @media only screen and (min-width: 480px) {
        font-size: 1.5rem;
      }

      h2,h3,h4 {
        span {
          color: #b2c5e7;

          &::before,
          &::after {
            display: none;
          }
        }
      }

      h2 {
        font-size: 2.4rem;
        padding: 1rem 0;
      }

      h2,
      h3 {
        @media only screen and (max-width: 479px) {
          font-size: 1.4rem!important;
        }
        margin: 16px 8px;
        text-align: center;
      }

      h4 {
        font-size: 2rem;
        line-height: 130%;
        margin: 16px 0;

        span {
          font-size: 1.6rem;
        }

        @media only screen and (min-width: 960px) {
          font-size: 2.4rem;
          margin: 24px 0;

          span {
            font-size: 1.8rem;
          }
        }
      }
    }

    tbody {
      tr:first-child {
        border-top: 0;

        td {
          border-top: 0;
        }
      }

      tr {
        &:nth-child(odd) {
          td {
            background: #fff;
          }
        }

        &:nth-child(even) {
          td {
            background: #f9fafc;
          }
        }

        &:hover {
          td {
            background: #feffdd;
          }
        }
      }

      a {
        transition: color 150ms ease-in;
        color: #3f62aa;
        border-bottom: 0!important;
        text-decoration: underline;

        &:hover,
        &:focus {
          color: #0976de;
          text-decoration: none;
        }
      }
    }

    td {
      background: #fff;
      border: 0;
      border-top: 1px solid #e3e3e3;
      border-right: 1px solid #e3e3e3;
      color: #000;
      height: 30px;
      padding: 0 3px;

      &.sep {
        background: #eff4ff!important;
        height: 5px;
      }

      @media only screen and (min-width: 800px) {
        height: 33px;
        padding: 0 10px;
      }

      &:nth-child(2) {
        font-weight: 600;
        text-align: center;
      }

      &:nth-child(6) {
        font-weight: 600;
      }

      &.legend {
        background: #fff!important;
        padding: 10px 20px;

        &--vertical {
          line-height: 180%;

          ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              margin: 0;
            }
          }

          p {
            display: inline-block;
            margin: 0!important;

            &::before {
              content: '';
              padding: 0;
            }
          }
        }

        span {
          margin-right: 8px;
        }

        .pmg {
          display: inline-block;
          line-height: 125%;
          text-align: center;
          width: 44px;
        }

        p {
          margin: 7px 0;
        }
      }
    }

    .val {
      font-weight: 600;

      em {
        border-radius: 5px;
        color: #fff;
        font-style: normal;
        padding: 1px 3px;
      }

      &--min {
        em {
          background: #e0167c;
          border: 1px solid #e0167c;
        }
      }

      &--max {
        em {
          background: #0d5fde;
          border: 1px solid #043b91;
        }
      }
    }

    .bar {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 24px;
      width: 0;
      border-radius: 0 6px 6px 0;
      background: #e5ebf8;
      transition: width 0.5s ease;
    }

    .bar-cell {
      position: relative;
      text-align: right;
      overflow: hidden;

      @media only screen and (min-width: 800px) {
        width: 220px;
      }

      &--max {
        .bar {
          background: #c3d0e8;
        }
        span {
          &::after {
            content: " ●";
          }
        }
      }

      span {
        position: relative;
        z-index: 2;
        font-weight: 700;
      }
    }

    .pmg {
      background: #f5faed;
      border: 1px solid #a0c279;
      padding: 2px 8px;
      border-radius: 5px;
      color: #03280d;
      font-weight: 600;

      @media only screen and (min-width: 800px) {
        font-size: 1.4rem;
      }
    }

    .badge {
      border-radius: 5px;
      color: #fff;
      font-weight: 600;
      font-size: 1.4rem;
      padding: 2px 8px;

      & + .badge {
        margin-left: 2px;
      }

      &--specimen {
        background: #ce2121;
      }

      &--dots  {
        background: #666fff;
      }

      &--orange  {
        background: #ef9523;
        padding: 2px 6px;
      }

      &--green  {
        background: #4ac032;
      }

      &--silver  {
        background: #8e8e8e;
      }

      &--gold  {
        background: #ffd226;
        color: #000;
      }
    }
  }

  .fact-box__copyright,
  .tab-fancy .copyright {
    background: #eff4ff!important;
    color: #163055;
    padding: 8px;
    text-align: center;

    @media only screen and (min-width: 640px) {
      padding: 16px;
    }

    p {
      font-size: 1.2rem;
      line-height: 150%;
      margin-bottom: 0;

      @media only screen and (min-width: 800px) {
        font-size: 1.4rem;
      }
    }

    a {
      transition: color 150ms ease-in;
      color: #3f62aa;
      border-bottom: 0;

      &:hover,
      &:focus {
        color: #0976de;
      }
    }
  }
`;

export default GlobalStyle;
